import React from 'react'
import {Box, TextProps, useMultiStyleConfig} from '@chakra-ui/react'

interface SpacerProps {
    spaceDesktop: string
    spaceTablet: string
    spaceMobile: string
    backgroundColor?: string
    additionalClass?: string
    extraCSS?: string
}

const Spacer: React.FC<SpacerProps> = ({spaceDesktop, spaceTablet, spaceMobile, backgroundColor, additionalClass, extraCSS}) => {
    const styles = useMultiStyleConfig('Spacer', {spaceDesktop, spaceTablet, spaceMobile, backgroundColor}) as Record<string, TextProps>

    return <Box {...styles.container} css={extraCSS} className={additionalClass} data-testid="spacer" />
}

export {Spacer}
